import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsRegisterHospitalsComponent } from './us-register-hospitals.component';

const usRegisterHospitalRoutes: Routes = [
  { path: '', component: UsRegisterHospitalsComponent, data: { title: 'U.S. Hospitals' } }
];

@NgModule({
  imports: [RouterModule.forChild(usRegisterHospitalRoutes)],
  exports: [RouterModule]
})
export class UsRegisterHospitalsRouting {}



// WEBPACK FOOTER //
// ./src/app/t2-us-register-hospitals/us-register-hospitals-routing.module.ts